<template>
  <div>
    <div class="content-block">
      <div>
        <div>
          <div class="asd-form-section">
            <div class="section-title">
              <h5>
                <i class="fas fa-th-large"></i>
                Nastavení
              </h5>
              <div class="section-title-controls">
                <button v-help.mouse="`Pridat svatv`"
                        class="asd-btn-edit"
                        @click="showStateEditor = true"
                >
                  <i class="fas fa-plus"></i>
                </button>
                <ActiveButton class="asd-btn-delete"
                              :click="deleteGraph"
                              confirmText="Opravdu chcete smazat tento graf?"
                >
                  <i class="fas fa-trash"></i>
                </ActiveButton>
                <ActiveButton class="asd-btn-confirm"
                              :click="save"
                >
                  <i class="fas fa-save"></i>
                </ActiveButton>
              </div>
            </div>
            <div class="asd-form">
              <div>
                <label for="default-state">Název</label>
                <input v-model="name"
                       class="asd-input"
                       type="text"
                       required
                />
              </div>
              <div>
                <label for="default-state">Stavy</label>
                <Multiselect
                  id="default-state"
                  v-model="states"
                  :max="-1"
                  label="label"
                  trackBy="id"
                  valueByPath="id"
                  :options="allStates"
                  :allowEmpty="false"
                  @input="throttledUpdate"
                >
                </multiselect>
              </div>
              <div>
                <label for="default-state">Výchozí stav</label>
                <Multiselect
                  id="default-state"
                  v-model="defaultState"
                  :max="1"
                  label="label"
                  trackBy="id"
                  valueByPath="id"
                  :options="selectedStates"
                  :returnAsSingle="true"
                  :allowEmpty="false"
                  @input="throttledUpdate"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <div class="asd-form-section">
            <div class="section-title">
              <h5>
                <i class="fas fa-angle-double-right"></i>
                Přechody
              </h5>
            </div>
            <table class="asd-table">
              <thead>
                <tr class="table-heading">
                  <th>
                    <button class="asd-btn-confirm asd-btn-single-icon"
                            @click="addEmptyConnection"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </th>
                  <th>
                    {{ $t('common.name') }}
                  </th>
                  <th>Ze stavu</th>
                  <th>Do stavu</th>
                  <th>Podmínka</th>
                </tr>
              </thead>
              <tbody class="double-rows">
                <template v-for="(c, $index) in connections">
                  <tr :key="c.id">
                    <td class="asd-btn-group">
                      <button type="button"
                              class="asd-btn-delete"
                              @click="deleteConnection($index)"
                      >
                        <i class="far fa-trash-alt"></i>
                      </button>
                    </td>
                    <td>
                      <input v-model="c.label"
                             class="asd-input"
                             type="text"
                             required
                             @input="throttledUpdate"
                      />
                    </td>
                    <td>
                      <Multiselect
                        :id="`connection-from-${c.from}`"
                        v-model="c.from"
                        :max="1"
                        label="label"
                        trackBy="id"
                        valueByPath="id"
                        :options="selectedStates"
                        :returnAsSingle="true"
                        :allowEmpty="false"
                        @input="throttledUpdate"
                      >
                      </multiselect>
                    </td>
                    <td>
                      <Multiselect
                        :id="`connection-from-${c.to}`"
                        v-model="c.to"
                        :max="1"
                        label="label"
                        trackBy="id"
                        valueByPath="id"
                        :options="selectedStates"
                        :returnAsSingle="true"
                        :allowEmpty="false"
                        @input="throttledUpdate"
                      >
                      </multiselect>
                    </td>
                    <td>
                      <Multiselect
                        :id="`guards-${c.id}`"
                        v-model="c.guards"
                        :max="-1"
                        label="label"
                        trackBy="id"
                        valueByPath="id"
                        :options="guards"
                        :allowEmpty="true"
                        @input="throttledUpdate"
                      >
                      </multiselect>
                    </td>
                  </tr>
                  <tr :key="`notifications-${c.id}`">
                    <td></td>
                    <td colspan="4">
                      <NotificationsEditor :value="c.notifications"
                                           @input="onNotificationsEditorInput($event, c.id)"
                      ></NotificationsEditor>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div id="entity-states-settings-detail">
        <div v-html="graph"></div>
      </div>
    </div>
    <Modal v-if="showStateEditor">
      <StatesEditor @done="showStateEditor = false"></StatesEditor>
    </Modal>
    <!-- <pre v-text="{states, connections, defaultState, endStates}">
    </pre> -->
    <!-- <div class="content-block">
      <div class="asd-form-section">
        <div class="section-title">
          <h5>
            <i class="fas fa-book-open"></i>
            Příklady
          </h5>
        </div>
        <div class="alert alert-info">
          <strong>Kliknutím</strong>
          na některý z příkladů dojde k přepsání celého nastavení tímto příkladem včetně stavů, přechodů a dalšího.
        </div>
        <div class="asd-form">
          <button v-for="(e, id) in examples" :key="id"
                  class="asd-btn-edit"
                  style="margin-right: 5px"
                  @click="loadExample(e.data)"
          >
            {{ e.label }}
          </button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import validate from 'uuid-validate'
import Viz from 'viz.js'
import { Module, render } from 'viz.js/lite.render'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import { get, has, map, indexOf, size, throttle, find } from 'lodash'
import examples from 'ENUMS/entity-states-examples'
import { createEmptyConnection } from './defaultObjects'
import Modal from 'CORE/components/modal/modal'
import StatesEditor from './states-editor'
import ActiveButton from 'CORE/components/form/active-button'
import NotificationsEditor from './notifications-editor'


const sanitizeGraphId = id => `_${id.replace(/\-/g, '')}`

const GUARDS = [
    {
        id: 'must_have_assignee',
        label: 'Musí mít zpracovatele',
    },
    {
        id: 'only_author',
        label: 'Pouze autor',
    },
    {
        id: 'must_comment_event',
        label: 'Musí být přidán komentář k přechodu',
    },
]

export default {
    name: 'EntityStatesSettingsDetail',
    components: {
        Multiselect,
        Modal,
        StatesEditor,
        ActiveButton,
        NotificationsEditor,
    },
    props: {
        entityStateId: {
            type: String,
            required: true,
            validator: value => validate(value, 4),
        },
    },
    data() {
        return {
            graph: undefined,
            graphData: {},
            graphValid: false,
            states: [],
            connections: [],
            defaultState: undefined,
            name: '',
            showStateEditor: false,
        }
    },
    computed: {
        guards() {
            return GUARDS
        },
        throttledUpdate() {
            return throttle(this.update, 500)
        },
        examples() {
            return examples
        },
        allStates() {
            return get(this.$store.getters.settings, `entity-states.states`, [])
        },
        selectedStates() {
            const states = get(this.$store.getters.settings, 'entity-states.states', [])
            return map(this.states, id => find(states, { id: id }))
        },
    },
    mounted() {
        const state = get(this.$store.getters.settings, `entity-states.graphs.${this.entityStateId}`, null)
        if (state !== null) {
            this.connections = get(state, 'connections', [])
            this.states = get(state, 'states', [])
            this.defaultState = get(state, 'defaultState')
            this.name = get(state, 'name', '')
            this.throttledUpdate()
        }
    },
    methods: {
        // loadExample(data) {
        //     this.states = data.states
        //     this.connections = data.connections
        //     this.defaultState = data.defaultState
        //     this.endStates = data.endStates
        // },
        async save() {
            this.throttledUpdate()
            const data = this.$store.getters.settings
            if (!has(data, 'entity-states')) {
                this.$set(data, 'entity-states', {})
            }
            if (!has(data['entity-states'], 'graphs')) {
                this.$set(data['entity-states'], 'graphs', {})
            }
            data['entity-states']['graphs'][this.entityStateId] = {
                states: this.states,
                connections: this.connections,
                defaultState: this.defaultState,
                name: this.name,
            }
            try {
                await this.$store.dispatch('saveCurrentUserCompanySettings', data)
                this.flash('Uloženo', 'success', {
                    timeout: 1500,
                })
                this.$emit('done')
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
        async deleteGraph() {
            const data = this.$store.getters.settings
            delete data['entity-states']['graphs'][this.entityStateId]
            try {
                await this.$store.dispatch('saveCurrentUserCompanySettings', data)
                this.flash('Smazáno', 'success', {
                    timeout: 1500,
                })
                this.$emit('done')
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
        deleteConnection($index) {
            this.$delete(this.connections, $index)
            this.throttledUpdate()
        },
        addEmptyConnection() {
            this.connections.push(createEmptyConnection())
        },
        onNotificationsEditorInput(e, id) {
            for (const c of this.connections) {
                if (c.id === id) {
                    this.$set(c, 'notifications', e)
                }
            }
            console.info(this.connections)
        },
        async update() {
            try {
                const states = this.states.map(s => {
                    s = find(this.allStates, { id: s })
                    const props = {}
                    props['label'] = s.label
                    if (s.id === this.defaultState) {
                        props['shape'] = 'doublecircle'
                    }
                    if (indexOf(this.endStates, s.id) >= 0) {
                        props['style'] = 'bold'
                    }
                    if (s.color !== null) {
                        props['color'] = s.color
                    }
                    const propsStr = map(props, (v, k) => `${k}="${v}"`).join(',')
                    return `${sanitizeGraphId(s.id)}[${propsStr}];\n`
                }).join('')
                const connections = this.connections.map(c => {
                    const props = {}
                    if (has(c, 'label')) {
                        props.label = `${c.label}`
                        props.labeldistance = '0'
                        if (size(c.guards) > 0) {
                            props['label'] = `${props['label']}*`
                        }
                        if (c.event === 'automatic') {
                            props['style'] = 'dashed'
                        }
                        // props.minlen = "2" // working
                        // props.labelhref = "http://www.google.com" // working
                    }
                    const propsStr = map(props, (v, k) => `${k}="${v}"`).join(',')
                    return `${sanitizeGraphId(c.from)} -> ${sanitizeGraphId(c.to)} [${propsStr}];\n`
                }).join('')
                const graphDef = `digraph g{ rankdir="TD"; graph [bgcolor="transparent" fontname = "helvetica"]; node [fontname = "helvetica"]; edge [fontname = "helvetica"]; ${states} \n ${connections} }`

                // console.info(graphDef)

                const viz = new Viz({ Module, render })
                const result = await viz.renderString(graphDef)
                this.graph = result
                this.graphValid = true
            } catch (e) {
                console.error(e)
                this.graphValid = false
            }
        },
    },
}
</script>

<style scoped lang="scss">
#entity-states-settings-detail {
    display: flex;
    flex-direction: row;
    & > div:first-child {
        flex-grow: 2;
        padding-right: 5px;

    }
    & > div:last-child {
        background-color: whitesmoke;
        border: 1px solid gainsboro;
        border-radius: 4px;
        box-shadow: inset 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
        margin: 5px;
        flex-grow: 1;
        text-align: center;
    }
}
</style>

